import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';

export interface GridAction {
  type: 'export' | 'columnChooser' | 'custom' | 'button';
  id?: string;
  title?: string;
  tooltip?: string;
  icon?: string;
  visible?: boolean;
  action?: () => void;
  buttonText?: string;
  buttonClass?: string;
  buttonStyle?: string;
}

export interface ColumnConfig {
  key: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-grid-actions',
  standalone: true,
  imports: [CommonModule, MaterialUIModule],
  templateUrl: './grid-actions.component.html',
  styleUrls: ['./grid-actions.component.scss']
})
export class GridActionsComponent {
  @Input() actions: GridAction[] = [];
  @Input() showColumnChooser: boolean = false;
  @Input() allColumns: ColumnConfig[] = [];
  @Input() visibleColumns: { [key: string]: boolean } = {};

  @Output() exportClick = new EventEmitter<void>();
  @Output() columnChooserToggle = new EventEmitter<void>();
  @Output() columnToggle = new EventEmitter<{ key: string; col: ColumnConfig }>();
  @Output() columnChooserClose = new EventEmitter<void>();
  @Output() customActionClick = new EventEmitter<GridAction>();

  hoverTooltipId: string | null = null;

  onActionClick(action: GridAction): void {
    if (action.type === 'export') {
      this.exportClick.emit();
    } else if (action.type === 'columnChooser') {
      this.columnChooserToggle.emit();
    } else if ((action.type === 'custom' || action.type === 'button') && action.action) {
      action.action();
      this.customActionClick.emit(action);
    }
  }

  get selectedCount(): number {
  return Object.values(this.visibleColumns).filter(v => v).length;
}

  onColumnClick(col: ColumnConfig): void {
    // If this is the last selected item → block unselect
    if (this.selectedCount === 1 && this.visibleColumns[col.key]) {
      return;
    }
    this.columnToggle.emit({ key: col.key, col });
  }

  onColumnKey(event: KeyboardEvent, col: ColumnConfig): void {
    const k = event && (event as KeyboardEvent).key;
      event.preventDefault();
      event.stopPropagation();
    if (k === 'Enter' || k === ' ') {
      if (this.selectedCount === 1 && this.visibleColumns[col.key]) {
        return;
      }
      this.columnToggle.emit({ key: col.key, col });
    }
  }

  closeColumnChooser(): void {
    this.columnChooserClose.emit();
  }

  getButtonId(action: GridAction): string {
    if (action.id) {
      return action.id;
    }
    const text = action.title || action.buttonText || action.type || 'custom';
    return 'gridactions_button_' + text.toLowerCase().replace(/\s+/g, '');
  }
}
